enum FinancingRequestTrackerName {
  Details = "Details"
}

export default FinancingRequestTrackerName;
